import { FC, useEffect, useState } from "react"
import { Actions, ControlProps } from "@jsonforms/core"
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react"
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material"
import InputSummary from "../NewForm/InputSummary"
import useDebouncedHandleChange from "../useDebouncedHandleChange"
import { useLocation } from "react-router-dom"

const UTextarea: FC<ControlProps> = (props) => {
  const { path, visible, label, schema, data:iData, handleChange: iHandleChange, required } = props
  const [errors, setErrors] = useState("")
  const { core, dispatch } = useJsonForms()
  const location = useLocation() 
  const  isSettingsRoute = location.pathname.includes("/settings/smartRxForms")
  const {data, handleChange} = useDebouncedHandleChange( iData, iHandleChange )
  const [inputValue, setInputValue] = useState(data || "")
  // If this schema is a settings field, we only show the placeholder when on the settings route.
  const _defaultPlaceholder = schema?.placeholder ?? ""
  const placeholderValue = schema?.isSettings && !isSettingsRoute ? "" : _defaultPlaceholder


  const updateErrors = (message: string) => {
    setErrors(message)
    dispatch &&
      dispatch(
        Actions.updateErrors([
          {
            instancePath: "/" + path,
            message,
            schemaPath: "",
            keyword: "",
            params: {},
          },
        ]),
      )
  }
  useEffect(() => {
    updateErrors(
      required && data?.length === 0 ? "This is a required field" : "",
    )
    if (data != inputValue) {
      setInputValue(data) // inputValue should not be in deps
    }
  }, [data, core?.validationMode])

  return (
    <>
      {visible && schema?.summary ? (
        <InputSummary label={label} inputVal={data} />
      ) : (
        visible && (
          <Box
            sx={{
              my: 1,
              display: schema.isSettings && isSettingsRoute ? "flex" : "",
              justifyContent: schema.isSettings && isSettingsRoute ? "flex-start" : "",
              pl: schema.isSettings && isSettingsRoute ? 1 : "",
            }}
          >
            <InputLabel
              error={!!(errors && core?.validationMode === "ValidateAndShow")}
              sx={{
                mb: 1,
                color: "rgba(0, 0, 0, 0.60)",
                "&.Mui-focused": {
                  color: "rgba(0, 0, 0, 0.60)",
                },
                // v1:
                width: schema.isSettings && isSettingsRoute ? "210px" : "100%",
                // v2:
                //  width: schema.isSettings && isSettingsRoute ? "200px" : "100%",
                whiteSpace: "normal",
                // v2:
                // minWidth: "200px",
              }}
            >
              {label}
            </InputLabel>
            <FormControl
              error={!!(errors && core?.validationMode === "ValidateAndShow")}
              variant={"outlined"}
              fullWidth={schema.isSettings && isSettingsRoute ? false : true}
            >
              <OutlinedInput
                id={label}
                multiline
                rows={schema.options.rows}
                value={inputValue ?? ""}
                placeholder={placeholderValue}
                onChange={(event: any) => {
                  if (event.target.value === inputValue) return
                  setInputValue(event.target.value)
                  handleChange(path, event.target.value)
                }}
                // v1:
                sx={{ width: schema.isSettings && isSettingsRoute ? "341px" : "100%" }}
                // v2:
                // sx={{ width: schema.isSettings && isSettingsRoute ? "250px" : "100%" }}
              />
              {!!(errors && core?.validationMode === "ValidateAndShow") && (
                <FormHelperText sx={{ marginLeft: 0 }}>{errors}</FormHelperText>
              )}
            </FormControl>
          </Box>
        )
      )}
    </>
  )
}

export default withJsonFormsControlProps(UTextarea)
